import { createComponent } from '../../../common/helper/create-component';
import Sticky from '../index.mpx?resolve';
createComponent({
    properties: {
        eleKey: {
            type: null,
            value: ''
        }
    },
    data: {
        cubeStickyEle: true,
        on: false,
        eleHeight: 'auto',
        eleContentStyle: ''
    },
    computed: {
        eleHeightStyle() {
            return {
                height: this.eleHeight
            };
        }
    },
    relations: {
        [Sticky]: {
            type: 'parent'
        }
    },
    methods: {
        setContentStyle(eleContentStyle) {
            this.eleContentStyle = eleContentStyle;
        },
        setOn(on) {
            this.on = on;
        },
        refresh() {
            // 重置高度为 auto，然后重新计算并设置固定高度
            this.eleHeight = 'auto';
            const query = this.createSelectorQuery();
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const that = this;
            query.select('.cube-sticky-ele').boundingClientRect((rect) => {
                if (rect && rect.height > 0) {
                    that.eleHeight = `${rect.height}px`;
                }
            });
            query.exec();
        }
    }
});
